const WEB_CREDENTIAL_PATH_PATTERN =
  /^\/(welcome|login|register|forgot-password|phone-login|phone-signup|phone-verify|verify-phone|verify-email|reset-password)(?:\/|$)/

/** A concrete credential screen, never the root handoff route. */
export function isWebCredentialPath(pathname: string): boolean {
  return WEB_CREDENTIAL_PATH_PATTERN.test(pathname)
}

/** Includes `/`, whose auth index chooses the correct first screen. */
export function isWebAuthPath(pathname: string): boolean {
  return pathname === '/' || isWebCredentialPath(pathname)
}
